import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Domain } from 'app/models/domain.model';
import { User } from 'app/models/user.model';
import { environment } from 'environments/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DomainsService {

  apiUrl: string = `${environment.apiUrl}domain`;
  constructor(private httpClient: HttpClient) { }

  saveDomain(domain: Domain) {
    try {
      if(domain.id){
        return this.httpClient.put<Domain>(this.apiUrl, domain).pipe(
          catchError(this.handleError)
        );
      }else{
        return this.httpClient.post<Domain>(this.apiUrl, domain).pipe(
          catchError(this.handleError)
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  getDomains(){
    let enterprise: User = JSON.parse(sessionStorage.getItem('loggedUser'));
    console.log(enterprise);
    return this.httpClient.get<Domain[]>(this.apiUrl + `?enterpriseId=${enterprise.databaseId}`)
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }

  getDomainById(id: number){
    return this.httpClient.get<Domain>(this.apiUrl + "/" + id);
  }

  getResume(id: number){
    return this.httpClient.get<any>(this.apiUrl+"/resume/"+id);
  }
}
